import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

let getAuthToken = null;

export const setPresaleV2AuthGetter = (tokenGetter) => {
  getAuthToken = tokenGetter;
};

const client = axios.create({
  baseURL: `${API_BASE_URL}/presale/v2`,
  timeout: 30000,
  headers: { 'Content-Type': 'application/json' },
});

client.interceptors.request.use(async (config) => {
  if (getAuthToken) {
    try {
      const token = await getAuthToken();
      if (token) config.headers.Authorization = `Bearer ${token}`;
    } catch (_) { /* proceed without token */ }
  }
  return config;
});

const unwrap = (p) => p.then((r) => r.data);

const presaleV2Service = {
  getPresaleInfo: () => unwrap(client.get('/info')),
  registerUser: (clerkId, email) => unwrap(client.post('/register', { clerkId, email })),
  connectWallet: (bscWalletAddress) => unwrap(client.post('/connect-wallet', { bscWalletAddress })),
  getDepositAddresses: () => unwrap(client.get('/deposit-addresses')),
  getDeposits: () => unwrap(client.get('/deposits')),
  getBalance: () => unwrap(client.get('/balance')),
  getTxHistory: () => unwrap(client.get('/tx-history')),
};

export default presaleV2Service;
